(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6350],{

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 87714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ exactSearch; }
/* harmony export */ });
var hasAtLeastNumbers = function(phrase) {
    var numbers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    var re = /\d/g;
    var repeats = ((phrase || "").match(re) || []).length;
    return repeats >= numbers;
};
var hashHyphens = function(phrase) {
    var indexOfHyphen = phrase.indexOf("-");
    return indexOfHyphen !== -1;
};
function exactSearch(phrase) {
    return hasAtLeastNumbers(phrase) || hashHyphens(phrase);
};


/***/ }),

/***/ 65017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useMyOrderPreferencesWithDefault; }
});

// EXTERNAL MODULE: ./src/data/fragments/preferences/appOrderPreferences.main.ts + 2 modules
var appOrderPreferences_main = __webpack_require__(79170);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/preferences/getMyOrderPreferences.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getMyOrderPreferences($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      ...appOrderPreferences\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getMyOrderPreferencesQuery = (0,lib["default"])(_templateObject(), appOrderPreferences_main/* default */.Z);
var useMyOrderPreferences = function(websiteId) {
    return (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getMyOrderPreferencesQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,isServerSide/* default */.Z)() || !websiteId,
        fetchPolicy: "cache-first",
        partial: true
    });
};

;// CONCATENATED MODULE: ./src/hooks/useMyOrderPreferencesWithDefault.ts

/**
 * NOTE: This must be SSR Compatible (i.e. it must not suspend nor return user data)
 */ function useMyOrderPreferencesWithDefault(website) {
    var ref = useMyOrderPreferences(website._id), queriedPrefs = ref.preferences, networkStatus = ref.networkStatus;
    var preferences = queriedPrefs ? queriedPrefs : {
        menuId: website.defaultMenuId
    };
    return {
        preferences: preferences,
        loading: networkStatus <= 2 || !website
    };
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMutate */ .Tu)();
    var track = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteLoyaltyConfig; }
/* harmony export */ });
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getActiveLoyaltyProgramConfig($websiteId: ID) {\n        loyaltyProgramConfig(websiteId: $websiteId) {\n          _id\n          name\n          active\n          maxRedeemAmount\n          minRedeemAmount\n          accumulationRate\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useWebsiteLoyaltyConfig(websiteId) {
    var ref = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId
    }), loyaltyProgramConfig = ref.loyaltyProgramConfig, loading = ref.loading, error = ref.error;
    return {
        loyaltyProgramConfig: loyaltyProgramConfig,
        loading: loading,
        error: error
    };
};


/***/ }),

/***/ 35451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NavbarLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5434);
/* harmony import */ var _helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55192);
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9177);
/* harmony import */ var _page_components_Order_CategoryPage_Content_TopRow_MobileCategoriesMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30121);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76701);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









function NavbarLinks(param) {
    var links = param.links, categories = param.categories, cpg = param.cpg;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMegaMenu = ref[0], setShowMegaMenu = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), categoriesMegaMenu = ref1[0], setCategoriesMegaMenu = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        x: 0,
        y: 0,
        triangleX: 0
    }), positionMenu = ref2[0], setPositionMenu = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref3[0], setOpen = ref3[1];
    var pageWidth = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var megamenu = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isMobile = pageWidth < 768;
    var timer = null;
    var handleMouseIn = function(all) {
        var menu = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (timer) {
            clearTimeout(timer);
        }
        setShowMegaMenu(true);
        if (menu) {
            var targetposition = all.target.getBoundingClientRect();
            var x = targetposition.x, y = targetposition.y, width = targetposition.width;
            var megamenuPosition = megamenu.current.getBoundingClientRect();
            var xPosition = (pageWidth - megamenuPosition.width) / 2;
            setPositionMenu({
                x: xPosition,
                y: y,
                triangleX: x - xPosition + width / 3
            });
        }
    };
    var handleMouseOut = function() {
        timer = setTimeout(function() {
            setShowMegaMenu(false);
        }, 500);
    };
    var handleClick = function() {
        setShowMegaMenu(false);
    };
    var sortCategories = function() {
        var categoriesInfo = [];
        categories.sort(function(a, b) {
            if (a.parent && b.parent) {
                return a.index - b.index;
            }
            if (a.parent) {
                return 1;
            }
            if (b.parent) {
                return -1;
            }
            return a.index - b.index;
        });
        categories.forEach(function(category) {
            if (category.parent) {
                var parent = categoriesInfo.find(function(categoryMenu) {
                    return categoryMenu._id === category.parent._id;
                });
                if (parent) {
                    parent.subcategories = parent.subcategories ? _toConsumableArray(parent.subcategories).concat([
                        category
                    ]) : [
                        category
                    ];
                }
            } else {
                categoriesInfo.push(category);
            }
        });
        setCategoriesMegaMenu(categoriesInfo);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        sortCategories();
        return function() {
            // cleanup function: clear timeout on unmount component
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);
    if (!links || !links.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
        style: {
            padding: cpg ? "5px 0" : "0 0 10px"
        },
        children: [
            links.map(function(link, index) {
                if (isMobile && link.showMegaMenu) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        rel: "noopener noreferrer",
                        onClick: function() {
                            return setOpen(true);
                        },
                        children: link.title
                    }, index);
                }
                if (!link.path.startsWith("/")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: link.path,
                        target: "_blank",
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        rel: "noopener noreferrer",
                        children: link.title
                    }, index);
                }
                var active = link.path === router.asPath;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                    href: isMobile && showMegaMenu ? "/" : link.path,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: function() {
                            if (link.showMegaMenu && isMobile) {
                                setOpen(true);
                                return;
                            }
                            if (!active) return;
                            var navbar = document.getElementsByClassName("mainNavbar")[0];
                            var height = navbar.clientHeight;
                            (0,_helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                element: navbar,
                                top: height
                            });
                        },
                        className: active ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().active) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        onMouseOver: function(event) {
                            if (link.showMegaMenu && !isMobile) {
                                handleMouseIn(event, true);
                            } else {
                                setShowMegaMenu(false);
                            }
                        },
                        onMouseOut: handleMouseOut,
                        children: link.title
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: megamenu,
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().megamenu),
                onMouseOver: handleMouseIn,
                onMouseOut: handleMouseOut,
                style: {
                    top: positionMenu.y + 34,
                    left: positionMenu.x,
                    visibility: showMegaMenu ? "visible" : "hidden"
                },
                children: [
                    categoriesMegaMenu.map(function(category) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().category),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/pedir/category/".concat(category._id),
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().categoryTitle),
                                        onClick: handleClick,
                                        children: category.name
                                    })
                                }),
                                category.subcategories ? category.subcategories.map(function(subcategory) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "/pedir/category/".concat(subcategory._id),
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().subcategoryTitle),
                                            onClick: handleClick,
                                            children: subcategory.name
                                        })
                                    }, subcategory._id);
                                }) : null,
                                category.subcategories ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/pedir/category/".concat(category._id),
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().seeAll),
                                        onClick: handleClick,
                                        children: [
                                            "Ver todos",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdChevronRight */ .FNi, {
                                                size: 10,
                                                color: "var(--primary-color)"
                                            })
                                        ]
                                    })
                                }) : null
                            ]
                        }, category._id);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().triangle),
                        style: {
                            top: -34,
                            left: positionMenu.triangleX
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Order_CategoryPage_Content_TopRow_MobileCategoriesMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                setOpen: setOpen
            })
        ]
    });
};


/***/ }),

/***/ 25538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Account; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/helpers/auth/loginViaAuth.ts
var auth_loginViaAuth = __webpack_require__(63601);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/hooks/useWebsiteLoyaltyConfig.main.ts
var useWebsiteLoyaltyConfig_main = __webpack_require__(87529);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/index.tsx + 4 modules
var Menu = __webpack_require__(3967);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/WebsiteCoins/index.tsx
var WebsiteCoins = __webpack_require__(59874);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/AccountIcon/index.tsx


function AccountIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Account/styles.module.css
var styles_module = __webpack_require__(41619);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Account/index.tsx










function Account(props) {
    var me = props.me, website = props.website, _navbar = props.navbar, navbar = _navbar === void 0 ? {} : _navbar;
    var loginViaAuth = (0,auth_loginViaAuth/* useLoginViaAuthWindow */.l)();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var loyaltyProgramConfig = (0,useWebsiteLoyaltyConfig_main/* default */.Z)(website._id).loyaltyProgramConfig;
    var login = function() {
        (0,events.sendEvent)(events.EVENTS.clicked.login);
        loginViaAuth();
    };
    var handleClick = function() {
        if (me) {
            toggleOpen();
        } else {
            login();
        }
    };
    var toggleOpen = function() {
        setOpen(function(e) {
            return !e;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).accountInfo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).person,
                onClick: handleClick,
                children: me ? me.name ? me.name : "Mi cuenta" : "Iniciar Sesi\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoins/* default */.Z, {
                loyaltyProgramConfig: loyaltyProgramConfig,
                me: me
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).options,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                    fallback: null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        pointsConfiguration: website.pointsConfiguration,
                        buttonColor: navbar.buttonColor || "#252525",
                        open: open,
                        toggleOpen: toggleOpen,
                        closeMenu: function() {
                            return setOpen(false);
                        },
                        onlyOptions: true
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 19405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NavbarCPG; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/hooks/useWebsiteLayout.ts
var useWebsiteLayout = __webpack_require__(18368);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Links/index.tsx
var Links = __webpack_require__(35451);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/ContactIcon/index.tsx


function ContactIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.025 10.7167L11.9083 10.475C11.4 10.4167 10.9 10.5917 10.5416 10.95L9.00831 12.4834C6.64997 11.2834 4.71664 9.35836 3.51664 6.9917L5.05831 5.45003C5.41664 5.09169 5.59164 4.5917 5.53331 4.08336L5.29164 1.98336C5.19164 1.1417 4.48331 0.508362 3.63331 0.508362H2.19164C1.24997 0.508362 0.46664 1.2917 0.524973 2.23336C0.96664 9.35003 6.65831 15.0334 13.7666 15.475C14.7083 15.5334 15.4916 14.75 15.4916 13.8084V12.3667C15.5 11.525 14.8666 10.8167 14.025 10.7167Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/HelpIcon/index.tsx


function HelpIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.00002 0.666687C4.40002 0.666687 0.666687 4.40002 0.666687 9.00002C0.666687 13.6 4.40002 17.3334 9.00002 17.3334C13.6 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6 0.666687 9.00002 0.666687ZM9.83335 14.8334H8.16669V13.1667H9.83335V14.8334ZM11.5584 8.37502L10.8084 9.14169C10.2084 9.75002 9.83335 10.25 9.83335 11.5H8.16669V11.0834C8.16669 10.1667 8.54169 9.33335 9.14169 8.72502L10.175 7.67502C10.4834 7.37502 10.6667 6.95835 10.6667 6.50002C10.6667 5.58335 9.91669 4.83335 9.00002 4.83335C8.08335 4.83335 7.33335 5.58335 7.33335 6.50002H5.66669C5.66669 4.65835 7.15835 3.16669 9.00002 3.16669C10.8417 3.16669 12.3334 4.65835 12.3334 6.50002C12.3334 7.23335 12.0334 7.90002 11.5584 8.37502Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/StoresIcon/index.tsx


function StoresIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "17",
        viewBox: "0 0 12 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.00002 0.666687C2.77502 0.666687 0.166687 3.27502 0.166687 6.50002C0.166687 9.97502 3.85002 14.7667 5.36669 16.5917C5.70002 16.9917 6.30835 16.9917 6.64169 16.5917C8.15002 14.7667 11.8334 9.97502 11.8334 6.50002C11.8334 3.27502 9.22502 0.666687 6.00002 0.666687ZM6.00002 8.58335C4.85002 8.58335 3.91669 7.65002 3.91669 6.50002C3.91669 5.35002 4.85002 4.41669 6.00002 4.41669C7.15002 4.41669 8.08335 5.35002 8.08335 6.50002C8.08335 7.65002 7.15002 8.58335 6.00002 8.58335Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/TopRibbon/styles.module.css
var styles_module = __webpack_require__(40046);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/TopRibbon/index.tsx







function TopRibbon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).topRibbon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/ayuda",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: "Ayuda"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/contacto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: "Contacto"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/locales",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).icon,
                                    children: "Locales"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Account/index.tsx + 1 modules
var Account = __webpack_require__(25538);
// EXTERNAL MODULE: ./src/hooks/useMyOrderPreferencesWithDefault.ts + 1 modules
var useMyOrderPreferencesWithDefault = __webpack_require__(65017);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/index.tsx + 10 modules
var Content = __webpack_require__(87336);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/CartIcon/index.tsx


function CartIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 16C4.9 16 4.01 16.9 4.01 18C4.01 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM0 1C0 1.55 0.45 2 1 2H2L5.6 9.59L4.25 12.03C3.52 13.37 4.48 15 6 15H17C17.55 15 18 14.55 18 14C18 13.45 17.55 13 17 13H6L7.1 11H14.55C15.3 11 15.96 10.59 16.3 9.97L19.88 3.48C20.25 2.82 19.77 2 19.01 2H4.21L3.54 0.57C3.38 0.22 3.02 0 2.64 0H1C0.45 0 0 0.45 0 1ZM16 16C14.9 16 14.01 16.9 14.01 18C14.01 19.1 14.9 20 16 20C17.1 20 18 19.1 18 18C18 16.9 17.1 16 16 16Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Cart/styles.module.css
var Cart_styles_module = __webpack_require__(68930);
var Cart_styles_module_default = /*#__PURE__*/__webpack_require__.n(Cart_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Cart/index.tsx








function Cart(props) {
    var website = (0,useInitialData/* default */.Z)().website;
    var preferences = (0,useMyOrderPreferencesWithDefault/* default */.Z)(website).preferences;
    var layout = props.layout;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useRef)(null);
    var toggleOpen = function() {
        setOpen(function(e) {
            return !e;
        });
    };
    var closeOpen = function() {
        setOpen(false);
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (ref1.current && !ref1.current.contains(event.target)) {
                closeOpen();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref1
    ]);
    if (!(preferences === null || preferences === void 0 ? void 0 : preferences.cart)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Cart_styles_module_default()).cartContainer,
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Cart_styles_module_default()).icon,
                onClick: toggleOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Cart_styles_module_default()).numberOfProducts,
                onClick: toggleOpen,
                children: preferences.cart && preferences.cart.items ? preferences.cart.items.length : 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Cart_styles_module_default()).container,
                style: {
                    transform: open ? "translateX(0)" : "translateX(-100vw)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Cart_styles_module_default()).title,
                        children: "Mi pedido"
                    }),
                    preferences.cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                        fallback: null,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default */.Z, {
                            preferences: preferences,
                            website: website,
                            layout: layout
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Cart_styles_module_default()).loadingContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Cart_styles_module_default()).loading
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Address/index.tsx + 7 modules
var Address = __webpack_require__(93154);
// EXTERNAL MODULE: ./src/components/ClickOutside/index.tsx
var ClickOutside = __webpack_require__(98816);
// EXTERNAL MODULE: ./src/hooks/useShouldUseNewAddressesUI.ts
var useShouldUseNewAddressesUI = __webpack_require__(17664);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx + 1 modules
var UpdateBasicOptions = __webpack_require__(82096);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/CaretIcon/index.tsx


function CaretIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.11997 1.29L5.99997 5.17L9.87997 1.29C10.27 0.899998 10.9 0.899998 11.29 1.29C11.68 1.68 11.68 2.31 11.29 2.7L6.69997 7.29C6.30997 7.68 5.67997 7.68 5.28997 7.29L0.699971 2.7C0.309971 2.31 0.309971 1.68 0.699971 1.29C1.08997 0.909998 1.72997 0.899998 2.11997 1.29Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/DeliveryIcon/index.tsx


function DeliveryIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "12",
        viewBox: "0 0 20 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.6667 5.16669C16.5167 5.16669 16.3667 5.19169 16.225 5.20835L14.5083 3.50002H15.8333C16.2917 3.50002 16.6667 3.12502 16.6667 2.66669V2.35002C16.6667 1.73335 16.0167 1.32502 15.4583 1.60835L13.5583 2.55835L11.4167 0.416687C11.2667 0.258354 11.05 0.166687 10.8333 0.166687H8.33333C7.875 0.166687 7.5 0.541687 7.5 1.00002C7.5 1.45835 7.875 1.83335 8.33333 1.83335H10.1417C10.3667 1.83335 10.575 1.92502 10.7333 2.07502L12.1583 3.50002H9.36667C9.23333 3.50002 9.10833 3.53335 8.99167 3.59169L6.375 4.90002C6.05833 5.05835 5.66667 5.00002 5.41667 4.74169L4.41667 3.74169C4.25833 3.59169 4.04167 3.50002 3.825 3.50002H0.833333C0.375 3.50002 0 3.87502 0 4.33335C0 4.79169 0.375 5.16669 0.833333 5.16669H3.33333C1.23333 5.16669 -0.408333 7.10002 0.0916667 9.28335C0.366667 10.4917 1.34167 11.4667 2.55 11.7417C4.73333 12.2417 6.66667 10.6 6.66667 8.50002L7.84167 9.67502C8.15833 9.99169 8.58333 10.1667 9.025 10.1667H9.86667C10.4667 10.1667 11.0167 9.85002 11.3167 9.32502L13.7417 5.08335L14.5833 5.92502C13.6417 6.68335 13.1167 7.93335 13.4333 9.30002C13.7167 10.5 14.6917 11.475 15.8917 11.75C18.0667 12.2417 20 10.5917 20 8.50002C20 6.65835 18.5083 5.16669 16.6667 5.16669ZM3.33333 10.1667C2.41667 10.1667 1.66667 9.41669 1.66667 8.50002C1.66667 7.58335 2.41667 6.83335 3.33333 6.83335C4.25 6.83335 5 7.58335 5 8.50002C5 9.41669 4.25 10.1667 3.33333 10.1667ZM16.6667 10.1667C15.75 10.1667 15 9.41669 15 8.50002C15 7.58335 15.75 6.83335 16.6667 6.83335C17.5833 6.83335 18.3333 7.58335 18.3333 8.50002C18.3333 9.41669 17.5833 10.1667 16.6667 10.1667Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Delivery/styles.module.css
var Delivery_styles_module = __webpack_require__(80987);
var Delivery_styles_module_default = /*#__PURE__*/__webpack_require__.n(Delivery_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Delivery/index.tsx













function Delivery() {
    // TODO: Refactor this so that it does not do props drilling on preferences
    var website = (0,useInitialData/* default */.Z)().website;
    var ref = (0,useMyOrderPreferencesWithDefault/* default */.Z)(website), preferences = ref.preferences, loading = ref.loading;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cartMenuV2.optionsLabel"
    }).t;
    var ref1 = (0,react.useState)(""), typeOfDelivery = ref1[0], setTypeOfDelivery = ref1[1];
    var ref2 = (0,react.useState)(""), deliveryAddress = ref2[0], setdeliveryAddress = ref2[1];
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var ref4 = (0,react.useRef)(null);
    var shouldUseNewAddressesUI = (0,useShouldUseNewAddressesUI/* default */.Z)();
    (0,react.useEffect)(function() {
        if (preferences.deliveryType === "delivery") {
            setTypeOfDelivery("Delivery a:");
            if (preferences.address) {
                setdeliveryAddress(preferences.address.address);
            } else {
                setdeliveryAddress(t("address"));
            }
        }
        if (preferences.deliveryType === "go") {
            setTypeOfDelivery("Retiro en:");
            if (!preferences.store) {
                setdeliveryAddress(t("store"));
            } else {
                setdeliveryAddress(t("storeGo", {
                    store: preferences.store.name
                }));
            }
        }
    }, [
        preferences
    ]);
    var toggleOpen = function() {
        setOpen(function(e) {
            return !e;
        });
    };
    var closeOpen = function() {
        setOpen(false);
    };
    if (loading || !(preferences === null || preferences === void 0 ? void 0 : preferences.cart)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Delivery_styles_module_default()).loading
    });
    var addressComponent = shouldUseNewAddressesUI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Address["default"], {
        closeModal: function() {
            setOpen(false);
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutside/* default */.Z, {
        onClickOutside: closeOpen,
        avoidElementName: "modal-root",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Delivery_styles_module_default()).options,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Delivery_styles_module_default()).optionsContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateBasicOptions/* default */.Z, {
                    preferences: preferences,
                    isFromHeader: true
                })
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Delivery_styles_module_default()).deliveryInfo,
        ref: ref4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Delivery_styles_module_default()).typeOfDelivery,
                onClick: toggleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Delivery_styles_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Delivery_styles_module_default()).text,
                        children: typeOfDelivery
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Delivery_styles_module_default()).addressContainer,
                onClick: toggleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Delivery_styles_module_default()).addressInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                            content: deliveryAddress,
                            className: (Delivery_styles_module_default()).tooltip,
                            children: deliveryAddress
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretIcon, {})
                ]
            }),
            open ? addressComponent : null
        ]
    });
};

// EXTERNAL MODULE: ./src/helpers/misc/exactSearch.ts
var exactSearch = __webpack_require__(87714);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/Icons/LupaIcon/index.tsx


function LupaIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5 11H11.71L11.43 10.73C12.63 9.33002 13.25 7.42002 12.91 5.39002C12.44 2.61002 10.12 0.390015 7.32001 0.0500152C3.09001 -0.469985 -0.469985 3.09001 0.0500152 7.32001C0.390015 10.12 2.61002 12.44 5.39002 12.91C7.42002 13.25 9.33002 12.63 10.73 11.43L11 11.71V12.5L15.25 16.75C15.66 17.16 16.33 17.16 16.74 16.75C17.15 16.34 17.15 15.67 16.74 15.26L12.5 11ZM6.50002 11C4.01002 11 2.00002 8.99002 2.00002 6.50002C2.00002 4.01002 4.01002 2.00002 6.50002 2.00002C8.99002 2.00002 11 4.01002 11 6.50002C11 8.99002 8.99002 11 6.50002 11Z",
            fill: "var(--navbar-text-color)"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/SearchBox/styles.module.css
var SearchBox_styles_module = __webpack_require__(38431);
var SearchBox_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchBox_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/SearchBox/index.tsx







function SearchBox(props) {
    var router = (0,next_router.useRouter)();
    var layout = props.layout;
    var searchParamString = layout.productsLayout === "categories" ? "q" : "search";
    var ref = (0,react.useState)(""), search = ref[0], setSearch = ref[1];
    var searchInput = (0,react.useRef)();
    var history = (0,next_router.useRouter)();
    var searchParamKey = router.query[searchParamString];
    var searchParam = Array.isArray(searchParamKey) ? searchParamKey[0] : searchParamKey;
    var searchInternalParam = Array.isArray(router.query.q) ? router.query.q[0] : router.query.q;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order"
    }).t;
    var makeSearch = function() {
        if (search) {
            var url = "/pedir?".concat(searchParamString, "=").concat(search);
            // We use shallow routing to force the page to be remounted
            // Otherwise it won't get picked up by the useEffect at useUrlSearch
            history.push(url, url, {
                shallow: true
            });
        }
    };
    (0,react.useEffect)(function() {
        if (searchParam && !(0,exactSearch/* default */.Z)(searchParam)) {
            setSearch(searchParam);
        } else {
            if (searchInternalParam && !(0,exactSearch/* default */.Z)(searchInternalParam)) {
                setSearch(searchInternalParam);
            }
        }
    }, [
        searchParam,
        searchInternalParam
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchBox_styles_module_default()).searchBarBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                placeholder: t("labelSearchProduct"),
                value: search,
                onChange: function(e) {
                    return setSearch(e.target.value);
                },
                ref: searchInput,
                onKeyPress: function(e) {
                    if (e.key === "Enter") {
                        makeSearch();
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SearchBox_styles_module_default()).searchButton,
                onClick: makeSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LupaIcon, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/styles.module.css
var NavbarCPG_styles_module = __webpack_require__(89021);
var NavbarCPG_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavbarCPG_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/NavbarCPG/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getUserInfoNavbarCPGs($websiteId: ID) {\n        me {\n          _id\n          name\n          email\n          roles\n          roleInWebsite(websiteId: $websiteId) {\n            _id\n            role\n          }\n          pointsInWebsite(websiteId: $websiteId)\n          websiteCoinsBalance(websiteId: $websiteId)\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















function NavbarCPG() {
    var website = (0,useInitialData/* default */.Z)().website;
    var layout = (0,useWebsiteLayout/* default */.Z)(website);
    var me = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: website._id
        },
        partial: true,
        omit: (0,isServerSide/* default */.Z)()
    }).me;
    var navbar = website && website.navbarConfiguration || {
        backgroundColor: "#fff",
        textColor: "#111",
        links: [],
        logo: null
    };
    var finalLogo = navbar.logo || website.logo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (NavbarCPG_styles_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRibbon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavbarCPG_styles_module_default()).headerActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NavbarCPG_styles_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[72px] w-48 relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        priority: true,
                                        layout: "fill",
                                        objectFit: "contain",
                                        src: finalLogo.url,
                                        alt: "Logo"
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {
                        layout: layout
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delivery, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Account/* default */.Z, {
                        me: me,
                        website: website
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                            layout: layout
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                fallback: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* default */.Z, {
                    links: navbar.links,
                    categories: website.categories,
                    cpg: true
                })
            })
        ]
    });
};


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RI": function() { return /* binding */ CartLoadingProvider; },
/* harmony export */   "k6": function() { return /* binding */ useCartLoading; }
/* harmony export */ });
/* unused harmony export CartLoadingContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var CartLoadingContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    loading: false,
    setLoading: function() {}
});
var useCartLoading = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(CartLoadingContext);
};
var CartLoadingProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartLoadingContext.Provider, {
        value: {
            loading: loading,
            setLoading: setLoading
        },
        children: children
    });
};


/***/ }),

/***/ 30121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MobileCategoriesMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50456);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32533);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95420);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61524);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCategoriesForMenu($websiteId: ID) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        name\n        subCategories {\n          items {\n            _id\n            name\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var styles = _objectSpread({}, (_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default()), (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default()));
var query = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__["default"])(_templateObject());
function MobileCategoriesMenu(param) {
    var setOpen = param.setOpen;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), selected = ref4[0], setSelected = ref4[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var i18nGeneric = "generic:fields";
    var i18nWebsite = "website:order";
    var ref1 = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useApolloQuery */ .Zu)({
        query: query,
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }), categories = ref1.categories, loading = ref1.loading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("/pedir/category/")) {
            var ref2, ref3;
            var categoryIdSelected = (ref3 = (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.split("/")) === null || ref3 === void 0 ? void 0 : ref3.pop();
            setSelected(categories.items.find(function(category) {
                return category._id === categoryIdSelected;
            }));
        }
    }, [
        router,
        categories.items
    ]);
    if (loading || !categories) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.closeMenu,
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: t("".concat(i18nGeneric, ".close"))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.loadingContainer,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.closeMenu,
                onClick: function() {
                    return setOpen(false);
                },
                children: t("".concat(i18nGeneric, ".close"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.container,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.categories,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles.header,
                            children: [
                                selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: styles.textWithIcon,
                                    onClick: function() {
                                        return setSelected(null);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdKeyboardArrowLeft */ .sG8, {
                                        size: "22"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: styles.primaryColor,
                                        onClick: function() {
                                            setOpen(false);
                                            router.push("/pedir/category/".concat(selected._id));
                                        },
                                        children: selected.name
                                    }) : t("".concat(i18nWebsite, ".labelCategories"))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.categoriesList,
                            children: (selected ? selected.subCategories : categories).items.map(function(category, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: styles.categoryItem,
                                    onClick: function() {
                                        setOpen(false);
                                        router.push("/pedir/category/".concat(category._id));
                                        setSelected(category);
                                    },
                                    children: category.name
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 76701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Bhhe5k9a_WLWLClklHD0I navbarLinksContainer","link":"_29RJklgC4kkTuDEjlOL0vL navbarLink appSubtitle","active":"BELM7cMsLwitWOnC5Cfn_ _29RJklgC4kkTuDEjlOL0vL navbarLink appSubtitle primaryColor","megamenu":"SCb_lPI4rQjnCY6wHU4UV","category":"_1fzOLdBax7bU6GI30z36Yh","categoryTitle":"_1jn8AhOjSPwFIPvbXE7fLe","subcategoryTitle":"_3C3QuVtyaKRxGmz2b2Do7H","seeAll":"x92lcwfCKfD5E6YzFCnaM","triangle":"iKj56B1nmRbQyMvLqOQm5"};

/***/ }),

/***/ 41619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountInfo":"Cv_scMvZRaajrwO7N2cu3","icon":"_2famJpOvjPhR_2AqLLN0Yt","container":"b3oMriSUuMtqIKbm5sraE content","options":"_2sM-QTzj7B2m0l85bB98yC b3oMriSUuMtqIKbm5sraE content"};

/***/ }),

/***/ 68930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cartContainer":"_657M5FGw5_2r4Vjf8B5Or","icon":"_38n0_O4MftOMFtAsbuv64n","numberOfProducts":"gbIi9yEfjizB51_mDP1q6","container":"_3yNdFUP-zf3jeIhSwbfNIR content","options":"XZvq09jRaLW3KdM-1XsIF _3yNdFUP-zf3jeIhSwbfNIR content","optionsContent":"_1GEvjik_9zfC5Sb-kBj-qb","title":"_1JMGAwzyMuEX-M6iWN6ig_ backgroundBorderColor","loadingContainer":"_1WiMCs4ReWxRaGT3UBLHog","loading":"_2nGoAPT2VBiw1Rmehl447w loadingGlow"};

/***/ }),

/***/ 80987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deliveryInfo":"_2wfFron1qYFvoULeEvM_N-","typeOfDelivery":"_1EFPnXQ9f2cx6xTFbNDzFn","icon":"_3qnrw9D3bYgaZoCrjXmbR","addressContainer":"_26OlWk9HoeUR5WTuPBbteS","addressInfo":"_3ySFnpDDMTAZV9UDWw0EDQ","tooltip":"_13usF8Bdj82LGP-p_hZsfo","container":"ci5j5H74K81FBMAoHAeUm content","options":"_3bzeD_aNaI1vaYMZak653F ci5j5H74K81FBMAoHAeUm content","optionsContent":"QCGvcXX-fkt3h1DpUfG7I"};

/***/ }),

/***/ 38431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchBarBox":"ETCRvpAJ-KssmiBTyD7m3","searchButton":"_1DG3rNdCyKC5K-13y3hUaL"};

/***/ }),

/***/ 40046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topRibbon":"_2hLqVkCSiocJrTELsHsy6f","icon":"_3dPh1Llplt2sIUW7rSf1O3"};

/***/ }),

/***/ 89021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"rtleqabQYqo9PxSzSWDke","headerActions":"_1ANiNt1TFcj6rK34x6LgV7","logo":"_1R1eNXLTqhGlLDpl5U_8yr"};

/***/ }),

/***/ 95420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forceColor":"_1FzGGrusCYvYM-XueTBsvV","textWithIcon":"_3RcLU2MDzPtl_RR3SB2g47","containerFilter":"_1XFUzAhca6UjQUXXl4C2bR","spaceLeft":"_8J5l1mYim_zM0CNKAr823"};

/***/ }),

/***/ 61524:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeMenu":"WWe4KToHi9GTHFilq-GsV backgroundBorderColor","container":"_3Ig1X2CpRdxln0tBfFuzs8","loadingContainer":"wRPw54j3maLrgH2qY5FNO _3Ig1X2CpRdxln0tBfFuzs8","categories":"_3gONsDeMv_nq-sU7Li3y7a","categoriesList":"_2UXV5eFFzhuUB_yAI_P6W7","categoryItem":"_3uZcKFmu1Q7TOMGRVzXrJp","header":"qIhDQetEVCYUMdj4bdCN3","primaryColor":"_37MkYbCMjWTk8635JHCKR6"};

/***/ })

}]);